// DO NOT EDIT -- generated from fs/services/search-settings/definedevents.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as pagination from '../../shared/pagination';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';

export namespace DefinedEvents {

  export const ArchiveDefinedEventEndpoint = "/grpc/search_settings.DefinedEvents/ArchiveDefinedEvent";
  /**
   * Archive an existing defined event for an org.
   * Once archived, the defined event cannot be modified and will not show up in GetAllDefinedEvents unless explicitly requested.
   */
  export function ArchiveDefinedEvent(sender: (req: ArchiveDefinedEventRequest, endpoint: string) => Promise<ArchiveDefinedEventResponse>, req: ArchiveDefinedEventRequest): { promise: () => Promise<ArchiveDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveDefinedEventEndpoint),
      endpoint: ArchiveDefinedEventEndpoint
    };
  }

  export const UnarchiveDefinedEventEndpoint = "/grpc/search_settings.DefinedEvents/UnarchiveDefinedEvent";
  /**
   * Unarchives an existing defined event for an org.
   * Once unarchived, the defined event can continue to be modified and will show up in GetAllDefinedEvents.
   */
  export function UnarchiveDefinedEvent(sender: (req: UnarchiveDefinedEventRequest, endpoint: string) => Promise<UnarchiveDefinedEventResponse>, req: UnarchiveDefinedEventRequest): { promise: () => Promise<UnarchiveDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveDefinedEventEndpoint),
      endpoint: UnarchiveDefinedEventEndpoint
    };
  }

  export const ArchiveMultiDefinedEventsEndpoint = "/grpc/search_settings.DefinedEvents/ArchiveMultiDefinedEvents";
  export function ArchiveMultiDefinedEvents(sender: (req: ArchiveMultiDefinedEventsRequest, endpoint: string) => Promise<ArchiveMultiDefinedEventsResponse>, req: ArchiveMultiDefinedEventsRequest): { promise: () => Promise<ArchiveMultiDefinedEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMultiDefinedEventsEndpoint),
      endpoint: ArchiveMultiDefinedEventsEndpoint
    };
  }

  export const UnarchiveMultiDefinedEventsEndpoint = "/grpc/search_settings.DefinedEvents/UnarchiveMultiDefinedEvents";
  export function UnarchiveMultiDefinedEvents(sender: (req: UnarchiveMultiDefinedEventsRequest, endpoint: string) => Promise<UnarchiveMultiDefinedEventsResponse>, req: UnarchiveMultiDefinedEventsRequest): { promise: () => Promise<UnarchiveMultiDefinedEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveMultiDefinedEventsEndpoint),
      endpoint: UnarchiveMultiDefinedEventsEndpoint
    };
  }

  export const GetAllDefinedEventsEndpoint = "/grpc/search_settings.DefinedEvents/GetAllDefinedEvents";
  /**
   * Get all current non-archived defined events for an org.
   * If desired, archived events can also be retrieved with the explicit request flag.
   */
  export function GetAllDefinedEvents(sender: (req: GetAllDefinedEventsRequest, endpoint: string) => Promise<GetAllDefinedEventsResponse>, req: GetAllDefinedEventsRequest): { promise: () => Promise<GetAllDefinedEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllDefinedEventsEndpoint),
      endpoint: GetAllDefinedEventsEndpoint
    };
  }

  export const GetDefinedEventEndpoint = "/grpc/search_settings.DefinedEvents/GetDefinedEvent";
  /** Get a specific defined event, either current or past version. */
  export function GetDefinedEvent(sender: (req: GetDefinedEventRequest, endpoint: string) => Promise<GetDefinedEventResponse>, req: GetDefinedEventRequest): { promise: () => Promise<GetDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventEndpoint),
      endpoint: GetDefinedEventEndpoint
    };
  }

  export const BatchGetDefinedEventsEndpoint = "/grpc/search_settings.DefinedEvents/BatchGetDefinedEvents";
  /** Get a specific set of defined events, either current or past versions. */
  export function BatchGetDefinedEvents(sender: (req: BatchGetDefinedEventRequest, endpoint: string) => Promise<BatchGetDefinedEventResponse>, req: BatchGetDefinedEventRequest): { promise: () => Promise<BatchGetDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetDefinedEventsEndpoint),
      endpoint: BatchGetDefinedEventsEndpoint
    };
  }

  export const SetDefinedEventEndpoint = "/grpc/search_settings.DefinedEvents/SetDefinedEvent";
  /** Add a new defined event or update an existing defined event. */
  export function SetDefinedEvent(sender: (req: SetDefinedEventRequest, endpoint: string) => Promise<SetDefinedEventResponse>, req: SetDefinedEventRequest): { promise: () => Promise<SetDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetDefinedEventEndpoint),
      endpoint: SetDefinedEventEndpoint
    };
  }

  export const GetDefinedEventsAccessEndpoint = "/grpc/search_settings.DefinedEvents/GetDefinedEventsAccess";
  export function GetDefinedEventsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventsAccessEndpoint),
      endpoint: GetDefinedEventsAccessEndpoint
    };
  }

  export const ListDefinedEventsEndpoint = "/grpc/search_settings.DefinedEvents/ListDefinedEvents";
  /**
   * Lists defined events, returning a batch of events and a pagination token.
   * A sane default limit per batch is enforced if not limit is provided.
   * Results are ordered by last modified date.
   */
  export function ListDefinedEvents(sender: (req: ListDefinedEventsRequest, endpoint: string) => Promise<ListDefinedEventsResponse>, req: ListDefinedEventsRequest): { promise: () => Promise<ListDefinedEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListDefinedEventsEndpoint),
      endpoint: ListDefinedEventsEndpoint
    };
  }
}

export namespace DefinedEventsPublic {

  export const ArchiveDefinedEventEndpoint = "/grpc/search_settings.DefinedEventsPublic/ArchiveDefinedEvent";
  /**
   * Archive an existing defined event for an org.
   * Once archived, the defined event cannot be modified and will not show up in GetAllDefinedEvents unless explicitly requested.
   */
  export function ArchiveDefinedEvent(sender: (req: ArchiveDefinedEventRequest, endpoint: string) => Promise<ArchiveDefinedEventResponse>, req: ArchiveDefinedEventRequest): { promise: () => Promise<ArchiveDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveDefinedEventEndpoint),
      endpoint: ArchiveDefinedEventEndpoint
    };
  }

  export const UnarchiveDefinedEventEndpoint = "/grpc/search_settings.DefinedEventsPublic/UnarchiveDefinedEvent";
  /**
   * Unarchives an existing defined event for an org.
   * Once unarchived, the defined event can continue to be modified and will show up in GetAllDefinedEvents.
   */
  export function UnarchiveDefinedEvent(sender: (req: UnarchiveDefinedEventRequest, endpoint: string) => Promise<UnarchiveDefinedEventResponse>, req: UnarchiveDefinedEventRequest): { promise: () => Promise<UnarchiveDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveDefinedEventEndpoint),
      endpoint: UnarchiveDefinedEventEndpoint
    };
  }

  export const GetAllDefinedEventsEndpoint = "/grpc/search_settings.DefinedEventsPublic/GetAllDefinedEvents";
  /**
   * Get all current non-archived defined events for an org.
   * If desired, archived events can also be retrieved with the explicit request flag.
   */
  export function GetAllDefinedEvents(sender: (req: GetAllDefinedEventsRequest, endpoint: string) => Promise<GetAllDefinedEventsResponse>, req: GetAllDefinedEventsRequest): { promise: () => Promise<GetAllDefinedEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllDefinedEventsEndpoint),
      endpoint: GetAllDefinedEventsEndpoint
    };
  }

  export const GetDefinedEventEndpoint = "/grpc/search_settings.DefinedEventsPublic/GetDefinedEvent";
  /** Get a specific defined event, either current or past version. */
  export function GetDefinedEvent(sender: (req: GetDefinedEventRequest, endpoint: string) => Promise<GetDefinedEventResponse>, req: GetDefinedEventRequest): { promise: () => Promise<GetDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventEndpoint),
      endpoint: GetDefinedEventEndpoint
    };
  }

  export const SetDefinedEventEndpoint = "/grpc/search_settings.DefinedEventsPublic/SetDefinedEvent";
  /** Add a new defined event or update an existing defined event. */
  export function SetDefinedEvent(sender: (req: SetDefinedEventRequest, endpoint: string) => Promise<SetDefinedEventResponse>, req: SetDefinedEventRequest): { promise: () => Promise<SetDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetDefinedEventEndpoint),
      endpoint: SetDefinedEventEndpoint
    };
  }

  export const GetDefinedEventsAccessEndpoint = "/grpc/search_settings.DefinedEventsPublic/GetDefinedEventsAccess";
  export function GetDefinedEventsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventsAccessEndpoint),
      endpoint: GetDefinedEventsAccessEndpoint
    };
  }
}

export interface ArchiveDefinedEventRequest {
  orgId: string;
  definedEventId: string;
}

export interface ArchiveDefinedEventResponse {
  definedEvent: DefinedEventRecord | null;
}

export interface ArchiveMultiDefinedEventsRequest {
  orgId: string;
  definedEventIds: string[];
}

export interface ArchiveMultiDefinedEventsResponse {
  definedEvents: DefinedEventRecord[];
}

export interface UnarchiveDefinedEventRequest {
  orgId: string;
  definedEventId: string;
}

export interface UnarchiveDefinedEventResponse {
  definedEvent: DefinedEventRecord | null;
}

export interface UnarchiveMultiDefinedEventsRequest {
  orgId: string;
  definedEventIds: string[];
}

export interface UnarchiveMultiDefinedEventsResponse {
  definedEvents: DefinedEventRecord[];
}

export interface GetAllDefinedEventsRequest {
  orgId: string;
  /** If true, archived defined events will also be returned. */
  includeArchived: boolean;
}

export interface GetAllDefinedEventsResponse {
  definedEvents: DefinedEventRecord[];
  /** The limit of active events. If length of active (i.e. non archived) events are at or over limit, new events will not be allowed. */
  activeLimit: number;
}

export interface GetDefinedEventRequest {
  /** required */
  orgId: string;
  /** required */
  definedEventId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetDefinedEventResponse {
  versions: DefinedEventRecord[];
}

export interface BatchGetDefinedEventRequest {
  /** required */
  orgId: string;
  /** required */
  identifiers: BatchGetDefinedEventRequest.Identifier[];
  /** optional, max number of records to return for unspecified versions; defaults to a single record */
  limit: number;
}

export namespace BatchGetDefinedEventRequest {
  export interface Identifier {
    /** required */
    definedEventId: string;
    /** optional. If not specified, the most recent [limit] versions will be returned. */
    version: protobuf.int64;
  }
}

export interface BatchGetDefinedEventResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found defined events will still be represented with an empty versions result set.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetDefinedEventResponse.Result[];
}

export namespace BatchGetDefinedEventResponse {
  export interface Result {
    identifier: BatchGetDefinedEventRequest.Identifier | null;
    versions: DefinedEventRecord[];
  }
}

export interface ListDefinedEventsRequest {
  orgId: string;
  pageInfo: pagination.PageInfoRequest | null;
  /** If non-zero, filters the response to just those modified since */
  modifiedSince: protobuf.timestamp | null;
  includeArchived: boolean;
}

export interface ListDefinedEventsResponse {
  definedEvents: DefinedEventRecord[];
  pageInfo: pagination.PageInfoResponse | null;
}

export interface SetDefinedEventRequest {
  orgId: string;
  /**
   * Defined event to be created or updated.
   * If the id field is not set, an id will be generated and a defined event will be stored.
   * TODO(clay - once client cuts over): If the id field is set, an existing defined event must already be persisted.
   */
  definedEvent: DefinedEvent | null;
  /**
   * If set, writes the defined event metadata as well.
   * If not set, the preexisting defined event metadata remains.
   */
  definedEventMetadata: DefinedEventMetadata | null;
  /**
   * If set, dedupes create requests containing the same idempotence key.
   * If idempotence key has already been handled, the existing entity will be returned instead of creating a new entity.
   * The idempotence key is only respected on create requests that let the server generate the entity id.
   * Note: This is best effort. Idempotence keys are kept around for three days but may be garbage collected sooner.
   */
  idempotenceKey: string;
}

export interface SetDefinedEventResponse {
  definedEvent: DefinedEventRecord | null;
}

export interface DefinedEvent {
  id: string;
  name: string;
  description: string;
  events: segment.Event[];
}

export interface DefinedEventMetadata {
  /**
   * When true, indicates the defined event should not typically be managed by users through the standard
   * defined event flows. Typically, this means that some other FS product will manage the defined event directly.
   */
  fsManaged: boolean;
}

export interface DefinedEventRecord {
  definedEvent: DefinedEvent | null;
  /** may be unset if no underlying metadata has ever been set */
  definedEventMetadata: DefinedEventMetadata | null;
  metadata: protoauditstore.AuditMetadata | null;
  /** empty if not created using idempotence key */
  createIdempotenceKey: string;
}
